// Query params ztc-core's OAuth redirects put on /dashboard/integrations/<slug>
// (IntegrationOAuthCallbackController, ComposioOAuthRedirectController).
export const ARRIVAL_PARAMS: ReadonlyArray<string> = ["installed", "connected", "error"];

export type Arrival =
  | { readonly kind: "installed" }
  | { readonly kind: "connected" }
  | { readonly kind: "error"; readonly code: string };

export type ArrivalContext = {
  readonly title: string;
  // An active connection already exists.
  readonly connected: boolean;
  // The page offers a Connect or Reconnect control right now.
  readonly canConnect: boolean;
};

export const readArrival = (params: URLSearchParams): Arrival | null => {
  const error = params.get("error");
  if (error !== null && error !== "") return { kind: "error", code: error };
  if (params.get("installed") === "1") return { kind: "installed" };
  if (params.get("connected") === "1") return { kind: "connected" };
  return null;
};

export const arrivalNotice = (arrival: Arrival, ctx: ArrivalContext): string => {
  const { title } = ctx;
  switch (arrival.kind) {
    case "error":
      return arrival.code.endsWith("access_denied")
        ? `Access to ${title} was declined, so nothing was connected. Connect again whenever you're ready.`
        : `${title} didn't finish connecting. Please try connecting again.`;
    case "connected":
      return `${title} is connected to your assistant.`;
    case "installed":
      if (ctx.connected) return `${title} is already connected to your assistant. You're all set.`;
      return ctx.canConnect
        ? `You've installed ZeroToClaw in ${title}. Connect ${title} below to finish linking it to your assistant.`
        : `You've installed ZeroToClaw in ${title}. Once your assistant is set up, come back here and connect ${title} to finish.`;
  }
};
